import { ACTION_NATIVE } from "@/modules/helpers/enum"

// Utility function for sending postMessage to React Native
export const sendToNative = (message: any) => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify(message))
  } else {
    console.warn("ReactNativeWebView not available")
  }
}

// Utility function for haptic feedback
export const sendHaptic = () => {
  queueMicrotask(() => sendToNative({ type: ACTION_NATIVE.HAPTIC }))
}

export const sendStoreReview = () => {
  sendToNative({
    type: ACTION_NATIVE.STORE_REVIEW,
    appId: "id6575385260",
    packageName: "com.zizi.project"
  })
}

export const sendOpenAppStoreReview = () => {
  sendToNative({
    type: ACTION_NATIVE.STORE_REVIEW
  })
}

export const sendLogout = () => {
  sendToNative({ type: ACTION_NATIVE.LOGOUT })
}

// Utility function for opening links
export const sendOpenLink = (url: string) => {
  sendToNative({ type: ACTION_NATIVE.OPEN_LINK, url })
}

export const sendStateNotification = () => {
  sendToNative({ type: ACTION_NATIVE.OPEN_SETTINGS })
}

// Utility function for token sync
export const sendTokenSync = () => {
  sendToNative({ type: ACTION_NATIVE.SYNC_TOKEN })
}

export const sendCopy = (text: string) => {
  if (window.ReactNativeWebView) {
    sendToNative({ type: ACTION_NATIVE.COPY, text })
  } else {
    // Try modern Clipboard API first
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(text).catch(() => {
        // Fallback for iframe or when Clipboard API fails
        fallbackCopyToClipboard(text)
      })
    } else {
      // Fallback for older browsers or restricted contexts
      fallbackCopyToClipboard(text)
    }
  }
}

// Fallback copy method for iframe and restricted contexts
const fallbackCopyToClipboard = (text: string) => {
  const textArea = document.createElement("textarea")
  textArea.value = text
  textArea.style.position = "fixed"
  textArea.style.left = "-9999px"
  textArea.style.top = "0"
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    document.execCommand("copy")
  } catch (err) {
    console.warn("Fallback copy failed:", err)
  }

  document.body.removeChild(textArea)
}

export const sendShare = (text: { url: string; title: string; message?: string }) => {
  sendToNative({
    type: ACTION_NATIVE.SHARE,
    data: { url: text.url, title: text.title, message: text.message }
  })
}
export const sendConnectTikTok = () => {
  sendToNative({ type: ACTION_NATIVE.CONNECT_TIKTOK })
}

export const sendAddBadgeCount = (count: number) => {
  sendToNative({ type: ACTION_NATIVE.ADD_BADGE_COUNT, count })
}

// Utility function for file picker
export const sendPickFiles = (options?: { multiple?: boolean; accept?: string }) => {
  sendToNative({
    type: ACTION_NATIVE.PICK_FILES,
    options: {
      multiple: options?.multiple || false,
      accept: options?.accept || "video/*,image/*"
    }
  })
}

// Utility function for opening app settings
export const sendOpenSettings = () => {
  sendToNative({ type: ACTION_NATIVE.OPEN_SETTINGS })
}

// Utility function for requesting camera
export const sendPermissionCamera = () => {
  sendToNative({ type: ACTION_NATIVE.REQUEST_PERMISSION, permission: "CAMERA" })
}

export const sendPermissionNotification = () => {
  sendToNative({ type: ACTION_NATIVE.OPEN_SETTINGS })
}

export const sendUpdateTokenFromWeb = (text: { accessToken: string; refreshToken: string }) => {
  sendToNative({
    type: ACTION_NATIVE.UPDATE_TOKEN_FROM_WEB,
    data: { accessToken: text.accessToken, refreshToken: text.refreshToken }
  })
}
